"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shorten = exports.isValid = void 0;
function isValid(addr) {
    return /^0x[a-fA-F0-9]{40}$/g.test(addr);
}
exports.isValid = isValid;
function shorten(address) {
    return address ? address.slice(0, 6) + '...' + address.slice(42 - 5) : '';
}
exports.shorten = shorten;
